import React, {useContext} from 'react';
import {Box, Typography, Button, Container, styled} from '@mui/material';
import {Link} from 'react-router-dom';
import {LanguageContext} from "../components/LanguageContext";

const ErrorContainer = styled(Container)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: theme.spacing(4),
    textAlign: 'center',
}));

const ErrorCode = styled(Typography)(({theme}) => ({
    fontSize: '6rem',
    fontWeight: 700,
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
}));

const ErrorMessage = styled(Typography)(({theme}) => ({
    fontSize: '1.5rem',
    marginBottom: theme.spacing(4),
}));

const ErrorPage = ({errorCode = 404, errorMessage, homeLink = "/home"}) => {
    const {translations} = useContext(LanguageContext);
    const message = errorMessage || translations.notFound;
    return (
        <ErrorContainer maxWidth="sm">
            <ErrorCode variant="h1">{errorCode}</ErrorCode>
            <ErrorMessage variant="h5">{message}</ErrorMessage>
            <Box mt={4}>
                <Button component={Link} to={homeLink} variant="contained" color="primary">
                    {translations.goHome}
                </Button>
            </Box>
        </ErrorContainer>
    );
};

export default ErrorPage;
